import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import styled, { useTheme } from 'styled-components';

const SelectWrapper = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.theme.spacing(2)};

  svg {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.textPrimary};
  }

  label {
    position: absolute;
    top: -10px;
    left: 45px;
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.inputGray};
    font-size: 14px;
    transition: all 0.2s ease;
    padding: 0 5px;
    pointer-events: none;
  }

  .select__control {
    background-color: ${(props) => props.theme.colors.surface};
    padding-left: 45px;
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid ${(props) => props.theme.colors.inputGray};
    border-radius: 5px;
    color: ${(props) => props.theme.colors.textPrimary};
    height: auto;
    outline: none;
    box-shadow: none;

    &:hover {
      border-color: ${(props) => props.theme.colors.textPrimary};
    }
  }

  .select__multi-value {
    background-color: ${(props) => props.theme.colors.inputGray};
    color: ${(props) => props.theme.colors.textPrimary};
    padding: 3px;
    font-size: 1.1em;
  }

  .select__multi-value__label {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .select__multi-value__remove {
    color: ${(props) => props.theme.colors.textPrimary};
    cursor: pointer;

    &::before {
      content: '×'; /* Display a visible X for removal */
      font-size: 1.2rem;
      margin-right: 5px;
      margin-top: -5px;
    }

    &:hover {
      background-color: ${(props) => props.theme.colors.primary};
      color: #fff;
    }
  }

  .select__menu {
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .select__option {
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.textPrimary};

    &:hover {
      background-color: ${(props) => props.theme.colors.primary};
      color: #fff;
    }
  }
`;

const CustomSelect = ({ icon, label, options, placeholder, onChange, value, isMulti }) => {
  const theme = useTheme();
  const [hasValue, setHasValue] = useState(false);

  useEffect(() => {
    if (value && value.length > 0) {
      setHasValue(true);
    } else {
      setHasValue(false);
    }
  }, [value]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: theme.colors.surface,
      borderColor: state.isFocused ? theme.colors.primary : theme.colors.inputBorder,
      boxShadow: state.isFocused ? `0 0 0 1px ${theme.colors.primary}` : 'none',
      paddingLeft: '45px',
      '&:hover': {
        borderColor: theme.colors.primary,
      },
      color: theme.colors.textPrimary,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: theme.colors.primary,
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: theme.colors.textPrimary,
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: theme.colors.textPrimary,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.colors.primary,
        color: '#fff',
      },
    }),
  };

  return (
    <SelectWrapper>
      {icon}
      <Select
        options={options}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        isMulti={isMulti}
        styles={customStyles}
        classNamePrefix="select"
      />
      <label className={hasValue ? 'active' : ''}>{label}</label>
    </SelectWrapper>
  );
};

export default CustomSelect;
